import React, { useState, forwardRef } from 'react'
import { Input } from 'antd'
import CountryCodePhonInput from '../CountryCodePhonInput'

import './MaterialInput.css'

const MaterialInput = forwardRef(
  (
    {
      className,
      errorText,
      iconClassName,
      containerClassName,
      hideLabel,
      ...others
    },
    ref
  ) => {
    let { label, type, required, value = '', placeholder } = others
    const [focus, setFocus] = useState(false)
    const requiredMark = required ? (
      <span className="text-danger">*</span>
    ) : null
    const hasIcon = !!iconClassName

    const isPassword = type === 'password'
    const isPhone = type === 'phone'

    return (
      <div
        className={
          errorText
            ? 'material-outline-input-container error ' + containerClassName
            : 'material-outline-input-container ' + containerClassName
        }
      >
        <div
          className={
            hasIcon ? 'material-textfield with-icon' : 'material-textfield'
          }
          onBlur={() => setFocus(false)}
          onFocus={() => setFocus(true)}
        >
          {!isPassword && !isPhone && (
            <input
              ref={ref}
              placeholder={placeholder}
              className={className}
              type={type}
              value={value}
              {...others}
            />
          )}
          {isPassword && (
            <Input.Password
              type={type}
              value={value}
              placeholder={placeholder}
              className={'input ' + className}
              {...others}
            />
          )}
          {isPhone && (
            <CountryCodePhonInput
              type="number"
              placeholder={placeholder}
              className={'input ' + className}
              {...others}
            />
          )}
          {hasIcon && <span className={'input-icon ' + iconClassName} />}
          {!hideLabel && (
            <label
              className={value || placeholder || focus ? 'with-value' : ''}
            >
              {label}
              {requiredMark}
            </label>
          )}
        </div>
        <div className="error"> {errorText} </div>
      </div>
    )
  }
)

export default MaterialInput
